import { connect } from 'react-redux';
import {
  loadDataSources,
  loadDataSource,
  loadDataMaps,
  setContextualSupport,
  unsetContextualSupport,
} from '../../actions';

import { getEligibleSourceEntities } from '../../reducers/selectors';
import {
  GET_DATA_SOURCES_REQUEST,
  GET_DATA_SOURCE_REQUEST,
  NEX_ORG_SWITCH_REQUEST,
} from '../../constants/actionTypes';
import { SearchFilterViews } from '../../constants/visibilityFilters';
import UIUtils from '../../lib/UIUtils';
import { getConnectionOrVendorType } from '../../lib/ResourceUtils';
import has from 'lodash/has';

import ViewDataSources from './ViewDataSources';
import * as OLD_PATHS from 'js/constants/pathnames';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_CONNECT } from 'new/constants/pathnames';
import { ModalFilePreview } from 'new/elements/ModalFilePreview';
import { ModalReingest } from 'new/elements/ModalReingest';

const mapStateToProps = (state, ownProps) => {
  const {
    app: {
      listing: { aclQueryMode, selectedCardId },
      visibilityFilters: { filters },
    },
    sources: { byId },
    request,
  } = state;
  const selectedCardID = state.app.listing.selectedCardId;
  const sourceId = UIUtils.extractParamFromURL(ownProps.match);

  const sources = getEligibleSourceEntities(state);
  const getSourceMeta = (sourceId) => {
    const {
      entities: { sources, vendors },
      paging: { metaInfoById },
    } = state;

    const sourceEntity = sources[sourceId];

    let connectionOrVendorType = getConnectionOrVendorType(
      sourceEntity,
      vendors,
      'source_type',
      'vendor_id',
    );

    return connectionOrVendorType && has(metaInfoById, connectionOrVendorType)
      ? metaInfoById[connectionOrVendorType]
      : null;
  };

  return {
    sourceId,
    selectedCardID,
    sources,
    allSources: byId,
    filters: filters[SearchFilterViews.SOURCES],
    aclQueryMode,
    // we'll only show loading if not showing detail view
    isLoading:
      (request[GET_DATA_SOURCE_REQUEST] && !selectedCardId) ||
      request[NEX_ORG_SWITCH_REQUEST] ||
      request[GET_DATA_SOURCES_REQUEST],
    getSourceMeta,
  };
};

const ViewDataSourcesContainer = connect(mapStateToProps, {
  loadDataSources,
  loadDataSource,
  loadDataMaps,
  setContextualSupport,
  unsetContextualSupport,
})(ViewDataSources);

export const viewDataSourcesScreenConfig = {
  screenName: 'Sources',
  domain: 'integrate',
  path: [`${ROUTE_REDESIGN}${ROUTE_CONNECT}${OLD_PATHS.ROUTE_DATA_SOURCES}`],
  exact: true,
  modals: [ModalFilePreview, ModalReingest],
  defaultProps: {
    onlyTableView: true,
  },
};

ViewDataSourcesContainer.screenConfig = viewDataSourcesScreenConfig;

export default ViewDataSourcesContainer;
